<div class="contract-switcher">
  <gp-dropdown-select #contractSelectionDropdown
                      (click-outside)="contractSelectionDropdown.open = false"
                      [ngModel]="selectedContract"
                      [hideToggle]="true"
                      [disabled]="contracts?.length === 1"
                      [customPlaceholderGenerator]="customPlaceholderGenerator"
                      test-id="contractEmployee"
                      (ngModelChange)="onSelectContract.emit($event)"
                      buttonClasses="btn"
                      menuClasses="dropdown-menu-right"
                      ngDefaultControl>
    <div *ngFor="let status of contractStatuses">
      <div class="regroupedStatus">{{'EMPLOYEE_FORM.' + status.toLowerCase() + '_contracts'| translate }}</div>
      <gp-dropdown-option *ngFor="let contract of regroupedContracts[status]"
                          [ngValue]="contract"
                          [class.non-active]="isInactiveContract(contract)"
                          [attr.test-id]="'contract-option' | gpTestId : 'employee-form' : contract.id">
        <div class="list-contracts">
          <img class="flag-icon"
               *ngIf="contract.flag"
               src="{{ contract.flag.href }}" alt="-"/>
          <span class="m-r-xs switch-contract-regulation"
                [class.font-weight-bold]="contract.id === selectedContract?.id"
                test-id="contract-name">{{ 'EMPLOYEE_FORM.Contract_name' | translate:{name: contract.cliRegNickName} }}</span>
          <span test-id="contract-dates" class="switch-contract-dates">{{ getContractDate(contract) }}</span>
        </div>
      </gp-dropdown-option>
    </div>
  </gp-dropdown-select>
</div>
